import { render, staticRenderFns } from "./Sit_Stand_Desks.vue?vue&type=template&id=f83a334e&"
import script from "./Sit_Stand_Desks.vue?vue&type=script&lang=js&"
export * from "./Sit_Stand_Desks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports